import type { ReactNode } from 'react';
import { cx, shortcutKeys } from '../utils.ts';
import './display.css';

export interface KbdProps {
  /** `'mod+k'` style shortcut, rendered per platform. */
  shortcut?: string;
  children?: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}

export function Kbd({ shortcut, children, size = 'md', className }: KbdProps) {
  const keys: ReactNode[] = shortcut ? shortcutKeys(shortcut) : [children];
  return (
    <span className={cx('g-kbd-group', className)} data-size={size}>
      {keys.map((k, i) => (
        <kbd key={i} className="g-kbd">
          {k}
        </kbd>
      ))}
    </span>
  );
}
